module.exports = __webpack_public_path__ + "img/medal2025.b93b7180.png";